var _style, _path, _defs, _defs2, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanetwin365({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3A3E45;}\n\t.st1{display:none;}\n\t.st2{display:inline;}\n\t.st3{display:inline;clip-path:url(#SVGID_00000170972979938319147690000014132642404481306013_);}\n\t.st4{clip-path:url(#SVGID_00000168074507039069051290000013147004183635171767_);}\n\t.st5{fill:#FFCB03;}\n\t.st6{display:none;fill:#3A3E45;}\n\t.st7{fill:#F9B515;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,0h60c5.5,0,10,4.5,10,10v60c0,5.5-4.5,10-10,10H10C4.5,80,0,75.5,0,70V10C0,4.5,4.5,0,10,0z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 18.5,
    y: 18.5,
    width: 43.1,
    height: 43.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028297736940913067210000010904451806654282140_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      clipPath: "url(#SVGID_00000028297736940913067210000010904451806654282140_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000178925792724456634400000000051300561180180664_",
    x: 18.5,
    y: 18.5,
    width: 43.1,
    height: 43.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091729963265244967940000012652773271267287727_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178925792724456634400000000051300561180180664_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000091729963265244967940000012652773271267287727_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M61.3,52.5c-0.6,3-2.5,5.4-5.2,6.8c-2.8,1.5-6,2-9.2,2.2c-2.7,0.1-5.5,0-8.3,0c3.8-1.1,7.2-3,10.4-5.3v-20 H25.4l3.3,9.1h8.8v5.1c-2.1,1.3-4.6,1.7-7,1.7c-2,0-4-0.4-5.8-1.4C18,47.4,16.6,38.2,21,32.5c2.2-2.9,5.6-4.4,9.3-4.3 c2.1,0,4.2,0.5,6.1,1.5c1.5,0.7,2.8,1.7,4.1,2.7l7.4-8.7c-1.2-0.9-2.3-1.8-3.6-2.6c-1.8-1.1-3.7-2-5.8-2.6H42 c3.3,0,6.6-0.1,9.7,1c1.9,0.6,3.6,1.7,5,3.2c1.5,1.8,2.3,4,2.3,6.3c0,3-1.1,5.8-3.5,7.7c-1.3,1-2.8,1.7-4.2,2.4 c3,1.1,6.1,2.2,8.3,4.6C61.5,46.1,61.8,49.6,61.3,52.5z"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M12.2,0C5.5,0,0,5.5,0,12.2v55.6C0,74.5,5.5,80,12.2,80h55.6C74.5,80,80,74.5,80,67.8V12.2 C80,5.5,74.5,0,67.8,0H12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M52,19.7c-0.3,3.1-3.4,6-6.8,6.6c-0.2,0.1-0.2,0.3,0,0.3c3.1,0.3,6,3.4,6.6,6.8c0.1,0.2,0.3,0.2,0.3,0 c0.3-3.1,3.4-6,6.8-6.6c0.2-0.1,0.2-0.3,0-0.3c-3.1-0.3-6-3.4-6.6-6.8C52.1,19.5,52,19.5,52,19.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M20.7,30c-3.3,2.6-6.1,9-6.1,14.4c-0.5,4.2,2.2,10.7,6,14.5c1.2,1.4,4.2,3.4,6.7,4.3c1.6,0.8,5.1,1.4,7.8,1.3 c4.1,0.4,10.4-2.4,14.1-6.1c3.2-2.5,5.8-8.8,5.9-14.1c0.1-0.9-0.1-2.8-0.4-4.3h-0.8c0.2,0.7,0.3,2.2,0.3,3.4c0.4,3.8-2,9.6-5.5,13 c-2.3,2.9-8,5.2-12.7,5.2h-0.3c-3.7,0.4-9.5-1.9-12.8-5.3c-3-2.3-5.5-8-5.7-12.9c-0.2-1.7,0.4-4.9,1.2-7.2c0.5-1.6,2.3-4.4,4-6.2 c2.4-3.1,8.4-5.5,13.3-5.4c0.8,0,2.6,0.2,3.9,0.5l0.1-0.2c0.1-0.1-0.2-0.3-0.7-0.4c-0.7-0.2-2.6-0.4-4.2-0.4 C30.8,23.6,24.4,26.2,20.7,30"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M27.7,54.4c-0.1,0-0.2-0.1-0.2-0.2V31.9c0-0.1,0.1-0.2,0.2-0.2c3.3-0.3,5.6-0.3,10.3-0.3 c7.7,0,10.1,1.7,10.1,7.3c0,5.6-2.3,7.3-9.3,7.3c-1.9,0-3.8-0.1-4.6-0.2c-0.5-0.1-0.9,1.2-0.9,2.7v5.6c0,0.1-0.1,0.2-0.2,0.2H27.7z  M37.9,41.7c3.4,0,4.3-0.6,4.3-3c1-1.6-0.9-3-4.3-3l-3.7,0c-0.5,0-0.9,0.4-0.9,0.9v4c0,0.5,0.4,0.9,0.9,0.9H37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M60.8,29.9c-0.2,2-2.2,4-4.4,4.3c-0.1,0.1-0.1,0.2,0,0.2c2,0.2,4,2.2,4.3,4.4c0.1,0.1,0.2,0.1,0.2,0 c0.2-2,2.2-4,4.4-4.3c0.1-0.1,0.1-0.2,0-0.2c-2-0.2-4-2.2-4.3-4.4C60.9,29.8,60.8,29.8,60.8,29.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M61,15.4c-0.2,1.7-1.9,3.4-3.8,3.8l0,0.2c1.7,0.2,3.4,1.9,3.8,3.8l0.2,0c0.2-1.7,1.9-3.4,3.8-3.8l0-0.2 c-1.9-0.4-3.4-1.9-3.8-3.8L61,15.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetwin365);
export default __webpack_public_path__ + "static/media/planetwin365.894336ead20466ec77f653c933f1bfb3.svg";
export { ForwardRef as ReactComponent };